import { createLazyReactDirective } from '../shell/createLazyReactDirective';

export default createLazyReactDirective(
  async () => (await import('./EntityTasks')).EntityTasks,
  'entityTasks',
  {
    dealId: '=',
    unitId: '=',
    leadId: '=',
    projectId: '=',
    extendedMode: '=?',
  },
);
